import { render, staticRenderFns } from "./Origin.vue?vue&type=template&id=46a4f5cc&"
import script from "../../model/article.js?vue&type=script&lang=js&"
export * from "../../model/article.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports